import { gql } from '@apollo/client'

export const GROUP_SECURITY_DETAILS_FRAGMENT = gql`
  fragment GROUP_SECURITY_DETAILS on SecurityGroup {
    id
    companyId
    name
    active
    createdAt
    businessRules {
      users {
        userOrPositionId
        securityProfileId
      }
      views {
        canView
        riskTemplateId
      }
    }
  }
`

export const GROUP_SECURITIES_QUERY = gql`
  query GROUP_SECURITIES_QUERY($filter: SecurityGroupFilterInput, $order: OrderInput, $pagination: PaginationInput) {
    securityGroups(filter: $filter, order: $order, pagination: $pagination) {
      data {
        ...GROUP_SECURITY_DETAILS
      }
      pagination {
        pageSkip
        pageTake
        totalCount
      }
    }
  }
  ${GROUP_SECURITY_DETAILS_FRAGMENT}
`
